module.exports = __webpack_public_path__ + "static/media/req.6bb4c8a7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/requisites/req.png
// module id = 546
// module chunks = 0